// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupTemplateThird_wrapper__uviWx","box":"PopupTemplateThird_box__1LG93"};